import { useEffect, useRef } from 'react';

import type { LanguageType } from '@/types/language';

import { trackFaqEvent } from './faqAnalytics';

export function useFaqAnalytics(
  locale: LanguageType,
  query: string,
  resultCount: number,
) {
  const viewed = useRef(false);
  const lastSearch = useRef('');

  useEffect(() => {
    if (!viewed.current && trackFaqEvent('faq_view', locale))
      viewed.current = true;
  }, [locale]);

  useEffect(() => {
    const normalized = query.trim();
    if (!normalized) {
      if (lastSearch.current) trackFaqEvent('faq_search_clear', locale);
      lastSearch.current = '';
      return;
    }
    if (lastSearch.current === normalized) return;
    const timer = window.setTimeout(() => {
      if (
        trackFaqEvent('faq_search', locale, {
          query_length: normalized.length,
          result_count: resultCount,
          has_results: resultCount > 0,
        })
      )
        lastSearch.current = normalized;
    }, 600);
    return () => window.clearTimeout(timer);
  }, [locale, query, resultCount]);
}
